export default __webpack_public_path__ + "static/media/logo.385971c3.svg";